import { timeToInt } from '../../../lib/dates';

/**
 * Validates a timeplanUnit
 * @param timeplanUnit record
 * @returns {boolean}
 */
export default function timeplanUnitValid(timeplanUnit) {
  const { from, to, date, workType } = timeplanUnit.toJS();
  if (!from || !to) {
    return false;
  }

  if (from.length !== 5 || to.length !== 5) {
    return false;
  }

  if (!from.includes(':') || !to.includes(':')) {
    return false;
  }

  try {
    if (timeToInt(to) === timeToInt(from)) {
      return false;
    }
  } catch (error) {
  }

  if (!date || !workType) {
    return false;
  }

  /**
   * Note: Missing resourceId validation since we are not currently doing that within
   * TimeplanField.
   */

  return true;
}
